import React, { useState } from "react";
import "../index.css";
import { Outlet, useLocation, Navigate, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Hora from "../components/Hora";
import Footer from "../components/Footer";
import useAuth from "../hooks/useAuth";
import ModalSumilla from "../components/ModalSumilla";
import ModalGruposHabilitados from "../components/ModalGruposHabilitados";
import ModalConfirmacionModalidad from "../components/ModalConfirmacionModalidad";
import { useEffect } from "react";
import $ from "jquery";
import { useIdleTimer } from "react-idle-timer";
import useMatricula from "../hooks/useMatricula";
import ModalSoporte from "../components/ModalSoporte";
import ModalCambioPrograma from "../components/ModalCambioPrograma";
import CryptoJS from "crypto-js";
import {
  apiDatosEstudiante,
  apiDatosSoporte,
  apiAsignatura,
  apiGrupos,
  apiRequisitoMat,
  apiProgramas,
  apiPeriodos,
  apiDocumentos,
  codigoApp,
  codigoIntitucion,
  keyPassLogin,
  timeOutCierreSesions,
} from "../config/constantes";
import { medirBackend } from "../utils/performance/perfTracker";
import ModalPDF from "../components/ModalPDF";
import ModalAgregarSeguro from "../components/ModalAgregarSeguro";
import ModalConfirmacionSeguro from "../components/ModalConfirmacionSeguro";
import ModalLoading from "../components/ModalLoading";
import ModalCruceHorario from "../components/Horario/ModalCruceHorario";
import ModalyaRegistrado from "../components/Horario/ModalyaRegistrado";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import ModalExonerado from "../components/Pagos/ModalExonerado";
import ModalTipoArchivoPeso from "../components/ModalTipoArchivoPeso";
import ModalErrorGenerarTokenUpch from "../components/Pagos/ModalErrorGenerarTokenUpch";
import { validarCrearToken } from "../utils/validarTokenGlo/validarTokenGlo";
import ModalHorarioError from "../components/Horario/ModalHorarioError";
import ModalAutorizacion from "../components/Autorizaciones/ModalAutorizacion/ModalAutorizacion";
import ModalSuccesTable from "../components/Autorizaciones/ModalSuccesTable/ModalSuccesTable";

const Layout = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const { auth, setAuth } = useAuth();
  const {
    listadoAsignaturas,
    setListadoAsignaturas,
    setGruposHabilitados,
    obtenerDatosEstudiante,
    setObtenerDatosEstudiante,
    setListadoSoporte,
    setlistadoRequisitosMatricula,
    setObtenerDatosEstudianteSinFiltro,
    setListadoPeriodo,
    listadoPrograma,
    setListadoPrograma,
    listaProgramas,
    setListadoInforMatriDocumento,
    seleccionPrograma,
    listadoRequisitosMatricula,
  } = useMatricula();

  const { loading, setLoading } = useProcesoMatricula();
  const [comienza, setComienza] = useState(0);

 
  let codIntitucion = Number(codigoIntitucion);
  let timeOutCierreSesion = Number(timeOutCierreSesions);

  

  useEffect(() => {
   
  }, [location]);
  const { pathname } = location;

  const prometeValidarApi = (api, config) => {
    return new Promise((resolver, rechazar) => {
      fetch(api, config).then((data) => {
       

        if (data.status == 200) {
          resolver(data);
        } else {
          rechazar(new Error(data));
        }
      });
    });
  };

  

  useEffect(() => {
    if (auth?._id) {
      const ejecutarPrimeraLlamada = async () => {
        await validarCrearToken(setAuth, navigate);
        let desencriptarTokenSesion = (pass) => {
          let token = pass == null ? "" : pass;
          // Decrypt
          var bytes = CryptoJS.AES.decrypt(token, `${keyPassLogin}`);
          var originalText = bytes.toString(CryptoJS.enc.Utf8);

          return originalText;
        };
      
        let codEstud = localStorage.getItem("token");
        

        let desencriptarCode = desencriptarTokenSesion(codEstud);
        let condicionDeCode = desencriptarCode == "" ? false : desencriptarCode;

        if (condicionDeCode !== false) {
          let listado_datosEstudiante_logeado = async () => {
            

            try {
              let tokenGlo = await validarCrearToken();

              let { access_token } = tokenGlo;
              if (access_token) {
                const config = {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ` + access_token,
                  },
                  body: JSON.stringify({
                    p_cusuario: condicionDeCode,
                    p_cinstitucion: codigoIntitucion,
                  }),
                };

                setLoading(true);
                const listaEstudiante = await medirBackend(
                  "layout_datos_estudiante",
                  "Datos del estudiante",
                  "Inicio",
                  () => prometeValidarApi(`${apiDatosEstudiante}`, config)
                );

                const listaEstudianteJson = await listaEstudiante.json();
                const { Data } = listaEstudianteJson;

             
                setObtenerDatosEstudianteSinFiltro(Data);
                let dataDefault = Data.filter((info) => {
                  return info.cinstitucion == codIntitucion && info.bdefecto;
                });

                setObtenerDatosEstudiante(dataDefault[0]);
                 
              }
            } catch (error) {
              setLoading(false);
              throw error;
            } finally {
              setLoading(false);
            }
          };

          if (!String(pathname).includes("/auth")) {
            try {
              listado_datosEstudiante_logeado();

              
            } catch (error) {
            } finally {
               
            }
          }

           

          var deviceAgent = navigator.userAgent.toLowerCase();
          var agentID = deviceAgent.match(/(iPad|iPhone|iPod)/i);
          if (agentID) {
            window.addEventListener("DOMContentLoaded", function () {
              $("body").addClass("iphone");
            });
          } else {
            $("#main-wrapper").addClass("default");
          }
        } else {
          localStorage?.removeItem("token");
          localStorage?.removeItem("tokenGlo");
          setAuth({});
          navigate("auth");
        }

        const horaFechaMenu = () => {
          let intervalo = setInterval(function () {
            var date = new Date();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var currentHours = date.getHours();
            var currentMinutes = date.getMinutes();
            var currentSeconds = date.getSeconds();
            currentMinutes = (currentMinutes < 10 ? "0" : "") + currentMinutes;
            currentSeconds = (currentSeconds < 10 ? "0" : "") + currentSeconds;

            var timeOfDay = currentHours < 12 ? "AM" : "PM";

            currentHours = currentHours > 12 ? currentHours - 12 : currentHours;
            currentHours = currentHours === 0 ? 12 : currentHours;

            let svg = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.525 10.2857H11.7625V12.5071L13.7755 13.6178L13.1568 14.6419L10.525 13.1924V10.2857ZM13.825 6.3471H2.275V15.0121H6.12775C5.773 14.2953 5.575 13.4918 5.575 12.6489C5.575 11.1865 6.18344 9.78396 7.26646 8.74987C8.34948 7.71577 9.81837 7.13483 11.35 7.13483C12.2327 7.13483 13.0742 7.32388 13.825 7.6626V6.3471ZM2.275 16.5876C1.35925 16.5876 0.625 15.8786 0.625 15.0121V3.98392C0.625 3.10954 1.35925 2.40846 2.275 2.40846H3.1V0.833008H4.75V2.40846H11.35V0.833008H13V2.40846H13.825C14.2626 2.40846 14.6823 2.57445 14.9917 2.8699C15.3012 3.16536 15.475 3.56608 15.475 3.98392V8.78905C16.498 9.78159 17.125 11.1444 17.125 12.6489C17.125 14.1113 16.5166 15.5139 15.4335 16.548C14.3505 17.5821 12.8816 18.163 11.35 18.163C9.77425 18.163 8.347 17.5643 7.3075 16.5876H2.275ZM11.35 8.82844C10.2888 8.82844 9.27107 9.23095 8.52069 9.94743C7.77031 10.6639 7.34875 11.6357 7.34875 12.6489C7.34875 14.76 9.139 16.4694 11.35 16.4694C11.8755 16.4694 12.3958 16.3706 12.8812 16.1786C13.3667 15.9866 13.8078 15.7052 14.1793 15.3504C14.5509 14.9956 14.8456 14.5745 15.0467 14.111C15.2478 13.6474 15.3513 13.1506 15.3513 12.6489C15.3513 10.5378 13.561 8.82844 11.35 8.82844Z" fill="#fefefe"/>
            </svg>`;
            if (document.querySelector("#clock-wrapper")) {
              document.querySelector("#clock-wrapper").innerHTML =
                svg +
                " " +
                (("" + day).length < 2 ? "0" : "") +
                day +
                "/" +
                (("" + month).length < 2 ? "0" : "") +
                month +
                "/" +
                date.getFullYear() +
                " &nbsp; " +
                currentHours +
                ":" +
                currentMinutes +
                ":" +
                currentSeconds +
                " " +
                timeOfDay;
            }
            
          }, 500);
          return () => clearInterval(intervalo);
        };

        horaFechaMenu();
      };

      ejecutarPrimeraLlamada();
    }
  }, [auth]);

  let { cinstitucion, cprograma, cperiodo, cpersona } =
    obtenerDatosEstudiante || {};
  

  useEffect(() => {
    let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

    let listado_programasEstudiante = async () => {
      const config = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ` + tokenGlos.access_token,
        },
        body: JSON.stringify({
          p_cinstitucion: cinstitucion,
          p_cpersona: cpersona,
        }),
      };
      try {
        setLoading(true);
        const listaProgramas = await medirBackend(
          "layout_lista_programas",
          "Lista de programas",
          "Inicio",
          () => prometeValidarApi(`${apiProgramas}`, config)
        );

        const listaProgramasJson = await listaProgramas.json();
        const { Data } = listaProgramasJson;
        setListadoPrograma(Data);
      } catch (error) {
        setLoading(false);
        throw error;
      } finally {
        setLoading(false);
      }
    };

    if (cinstitucion) {
      listado_programasEstudiante();
    }
  }, [obtenerDatosEstudiante]);

  useEffect(() => {
    let { cinstitucion, cpersona } = obtenerDatosEstudiante || {};
    let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
    if (cinstitucion && cpersona && seleccionPrograma) {
       
      let listado_periodosEstudiante = async () => {
        const config = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ` + tokenGlos.access_token,
          },
          body: JSON.stringify({
            p_cinstitucion: cinstitucion,
            p_cprograma: seleccionPrograma,
            p_cpersona: cpersona,
          }),
        };
        try {
          setLoading(true);
          const listaPeriodos = await medirBackend(
            "layout_lista_periodos",
            "Lista de periodos",
            "Inicio",
            () => prometeValidarApi(`${apiPeriodos}`, config)
          );

          const listaPeriodosJson = await listaPeriodos.json();
          const { Data } = listaPeriodosJson;
          setListadoPeriodo(Data);
        } catch (error) {
          setLoading(false);
          throw error;
        } finally {
          setLoading(false);
        }
      };

      try {
       
        listado_periodosEstudiante();
      } catch (error) {
      } finally {
         
      }
    }
  }, [seleccionPrograma, obtenerDatosEstudiante]);

  return (
    <>
      {auth._id ? (
        <>
          <div id="main-wrapper">
            <Header />

            <div
              className={`page-wrapper ${pathname == "/" && "site-home"} ${
                pathname == "/matricula" && "site-matricula"
              }`}
            >
              {/* <Hora /> */}
              <div className="container">
                <div className={`row ${pathname == "/" && "order-wrapper"}`}>
                  <Outlet />
                </div>
              </div>
            </div>

            <ModalGruposHabilitados />
            <ModalSumilla />
            <ModalConfirmacionModalidad />
            <ModalPDF />
            <ModalCambioPrograma />
            {/* <ModalSoporte /> */}
            <ModalConfirmacionSeguro />
            <ModalAgregarSeguro />
            <ModalCruceHorario />
            <ModalyaRegistrado />
            {loading && <ModalLoading />}
            <ModalTipoArchivoPeso />
            <ModalErrorGenerarTokenUpch />
            <ModalHorarioError />

             
          </div>

          <Footer />
          <ModalSuccesTable />
        </>
      ) : (
        <Navigate to="/auth" />
      )}
    </>
  );
};

export default Layout;
